import { isEqual, isUndefined } from 'lodash-es';

const onceRenewable = <V, T>(fn: (arg: V) => T) => {
  let lastArg: V | undefined;

  return (value: V) => {
    const shouldSkip = !isUndefined(value) && isEqual(value, lastArg);

    if (shouldSkip) {
      return undefined;
    }

    lastArg = value;

    return fn(value);
  };
};

export default onceRenewable;
